import { get, post } from './http'

const lifeStudioPath = '/operating-platform/campaign/frontend/life/studio'
const LIFESTUDIO = {
  // 获取产品列表
  getOnlineProduct: () => {
    return get(`${lifeStudioPath}/getsOnline`)
  },
  // 产品详情
  getProductDetail: (params) => {
    return get(`${lifeStudioPath}/get`, params)
  },
  // 通过urlName查询产品详情 
  getProductDetailByName: (params) => {
    return get(`${lifeStudioPath}/getByName`, params)
  },
  // 推荐产品 
  getRecommendProduct: (params) => {
    return get(`${lifeStudioPath}/recommend`, params)
  },
  // 热门留言
  getHotNote: (params) => {
    return get('/operating-platform/campaign/frontend/note/gets/top', params)
  },
  // 点赞
  praiseProduct: (params) => {
    return post(`${lifeStudioPath}/praise`, params)
  },
  // 留言板点赞
  praiseNoteBoard: (params) => {
    return post('operating-platform/campaign/frontend/note/praise', params)
  }
}


export default LIFESTUDIO